import Vue from "vue";
import { Component } from "vue-property-decorator";
import { AlerteDto } from "../../../../dto/GenApi.iNotPaie.Dto/AlerteDto";
import { ServicesFactoryInstance } from "../../../Controls/ServicesFactory";
import $ from "jquery";
import { ParametresInstance } from "../../../Controls/Parameters";
import { EventBus } from "../../../Controls/EventBus";
import EventConstants, { RoleConstants } from "../../../Controls/EventConstants";
import { NiveauAlerte } from "../../../../dto/GenApi.iNotPaie.Dto/NiveauAlerte";
import { TypeAlerte } from "../../../../dto/GenApi.iNotPaie.Dto/TypeAlerte";

@Component({
	components: {
		ModalCardAlert: require("../../modals/modalCardAlert/modalCardAlert.vue.html")
	}
})
export default class CardAlertComponent extends Vue {
	public dataReady = false;
	public alertesFiltred: AlerteDto[] = [];
	public roles: string[] = [];
	public isAdminPst = false;
	public isUtilisateurPst = false;
	public isPayeur = false;
	public isAdmin = false;
	public niveauAlerte = NiveauAlerte;
	public alertPermissionsMap: { [key: string]: boolean } = {};

	public errorGetAlerte = false;
	public mounted(): void {
		this.isAdminPst = ParametresInstance.userIsAuthorized([RoleConstants.AdministrateurPST]);
		this.isUtilisateurPst = ParametresInstance.userIsAuthorized([RoleConstants.UtilisateurPST]);
		this.isPayeur = ParametresInstance.userIsAuthorized([RoleConstants.Payeur]);
		this.isAdmin = ParametresInstance.userIsAuthorized([RoleConstants.Administrateur]);

		// Définie les alertes diponibles en fonction des différents rôles
		this.alertPermissionsMap = {
			[TypeAlerte.NC]: false,
			[TypeAlerte.FinPeriodeEssais]: this.isAdmin || this.isAdminPst || this.isPayeur,
			[TypeAlerte.FinContratCDD]: this.isAdmin || this.isAdminPst || this.isPayeur,
			[TypeAlerte.RappelRenouvellementFormation]: this.isAdmin || this.isAdminPst || this.isPayeur,
			[TypeAlerte.RappelRenouvellementVisiteMedicale]: this.isAdmin || this.isAdminPst || this.isPayeur,
			[TypeAlerte.FinValiditeCarteSejour]: this.isUtilisateurPst,
			[TypeAlerte.ValidationEntreeSalarie]: this.isUtilisateurPst,
			[TypeAlerte.EntreeSalarieAValider]: this.isAdminPst,
			[TypeAlerte.ClotureExercice]: this.isAdmin || this.isAdminPst || this.isPayeur,
			[TypeAlerte.ClotureDSN]: this.isAdmin || this.isPayeur || this.isAdminPst,
			[TypeAlerte.TauxPas]: this.isAdminPst || this.isPayeur,
			[TypeAlerte.FinPrevisionnelleCDD]: this.isAdmin || this.isAdminPst || this.isPayeur,
			[TypeAlerte.DpaeARealiser]: this.isAdmin || this.isAdminPst || this.isPayeur
		};

		EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
			this.fetchData();
		});

		EventBus.$on(EventConstants.RELOAD_ACCUEIL, () => {
			this.fetchData();
		});

		this.fetchData();
	}

	public fetchData(): void {
		ServicesFactoryInstance.AccueilService.getAlertes(data => {
			// Filtre les alertes en fonction des accès donnés par typeAlerteMap
			this.alertesFiltred = data
				.filter(a => Object.entries(this.alertPermissionsMap)
					.find(([key, value]) => Number(key) == a.TypeAlerte && value));
			this.dataReady = true;
			this.errorGetAlerte = false;
		}, () => {
			this.dataReady = true;
			this.errorGetAlerte = true;
		});
	}

	public clickEvent(alerte: AlerteDto): boolean {
		let isClickable = true;

		if (alerte.FullNameSalarie == undefined) {
			if (alerte.TypeAlerte == TypeAlerte.ClotureDSN) {
				EventBus.NavigateTo({ path: "/dsn" });
			} else if (alerte.TypeAlerte == TypeAlerte.ClotureExercice) {
				EventBus.$emit(EventConstants.MODAL_CLOTURE_PAIE);
			} else if (alerte.TypeAlerte == TypeAlerte.DpaeARealiser) {
				EventBus.NavigateTo({ path: "/dpae" });
			} else {
				isClickable = false;
			}
		} else {
			if ((this.isAdmin || this.isAdminPst || this.isPayeur) && alerte.TypeAlerte == TypeAlerte.FinPrevisionnelleCDD) {
				this.openQualification(alerte.IdSalarie, alerte.FullNameSalarie);
			} else if (this.isUtilisateurPst && alerte.TypeAlerte == TypeAlerte.FinValiditeCarteSejour) {
				this.openDeclaration(alerte.IdSalarie, alerte.FullNameSalarie);
			}
			else if (this.isUtilisateurPst) {
				this.openEntree(alerte.IdSalarie, alerte.FullNameSalarie);
			} else {
				this.openSalarie(alerte.IdSalarie, alerte.FullNameSalarie);
			}
		}

		isClickable = false;

		return isClickable;
	}

	public isClickable(alerte: AlerteDto): boolean {
		if (alerte.FullNameSalarie == undefined) {
			switch (alerte.TypeAlerte) {
				case TypeAlerte.ClotureExercice:
				case TypeAlerte.DpaeARealiser:
				case TypeAlerte.ClotureDSN:
					return true;
					break;
			}
		} else {
			return true;
		}

		return false;
	}

	public openAll(): void {
		$("#modalCardAlert").modal("show");
	}

	public openSalarie(idSalarie: number, libelle: string): void {
		EventBus.NavigateTo({
			path: "/ficheSalarie/" + idSalarie,
			query: { titre: libelle }
		});
	}

	public openEntree(id: number, libelle: string): void {
		EventBus.NavigateTo({
			path: "/entreeSalarie/" + id,
			query: { titre: libelle }
		});
	}

	public openQualification(idSalarie: number, libelle: string): void {
		EventBus.NavigateTo({
			path: "/ficheSalarie/" + idSalarie,
			query: { titre: libelle, onglet: "4" }
		});
	}

	public openDeclaration(idSalarie: number, libelle: string): void {
		EventBus.NavigateTo({
			path: "/ficheSalarie/" + idSalarie,
			query: { titre: libelle, onglet: "2" }
		});
	}
}



// WEBPACK FOOTER //
// ./src/components/home/cards/cardAlert/cardAlert.ts